import Modal from 'antd/es/modal';
import Popover from 'antd/es/popover';
import dayjs from 'dayjs';
import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import userDefaultAvatar from '../../../../assets/img/placeholder-user.png';
import { ReactComponent as MenuSvg } from '../../../../assets/svg/icons/menu.svg';
import { ReactComponent as SmileySvg } from '../../../../assets/svg/icons/smiley.svg';
import { onUserImgError } from '../../../../helpers/Helpers';
import { GET_PROSPECT_INFO } from '../../../../redux/actions/currentChatActions';
import { SHOW_INVITE_USERS } from '../../../../redux/actions/messagesActions';
import FeedbackPopup from '../popups/FeedbackPopup';

import { Button, Image } from 'antd';
import duration from 'dayjs/plugin/duration';
dayjs.extend(duration);

const AmbassadorMessagingHeader = ({
    handleSurePopupClick,
    showOptions,
    handleShowOptionsClickOnMobile,
    hideOptions,
    isMobile,
}) => {
    const dispatch = useDispatch();

    const account = useSelector((state) => state.account);
    const currentChat = useSelector((state) => state.currentChat);
    const messages = useSelector((state) => state.messages);

    const [isFeedbackModalActive, setIsFeedbackModalActive] = useState(false);
    const [isFeedbackSuccessModalActive, setIsFeedbackSuccessModalActive] = useState(false);
    const [showHintFeedback, setShowHintFeedback] = useState(true);

    const handleOpenInviteAmbassadorsPopup = useCallback(() => {
        hideOptions();
        dispatch({
            type: SHOW_INVITE_USERS,
            payload: { inviteUsersIsOpened: true },
        });
    }, [dispatch, hideOptions]);

    const handleOpenInviteAdminsPopup = useCallback(() => {
        hideOptions();
        dispatch({
            type: SHOW_INVITE_USERS,
            payload: { inviteUsersIsOpened: true, type: 'admins' },
        });
    }, [dispatch, hideOptions]);

    const showFeedbackModal = useCallback(() => {
        hideOptions();
        setIsFeedbackModalActive(true);
        setShowHintFeedback(false);
    }, [hideOptions]);

    const hideFeedbackModal = useCallback((simpleClose) => {
        setIsFeedbackModalActive(false);
        if (!simpleClose) {
            setIsFeedbackSuccessModalActive(true);
        }
    }, []);

    const hideFeedbackSuccessModal = useCallback(() => {
        setIsFeedbackSuccessModalActive(false);
    }, []);

    const skipFeedback = useCallback(() => {
        setShowHintFeedback(false);
    }, []);

    const onAvatarClick = useCallback(
        (currentChatInfo, hideOptions) => {
            dispatch({
                type: GET_PROSPECT_INFO,
                payload: {
                    prospectId: currentChatInfo.prospect.id,
                },
            });

            hideOptions();
        },
        [dispatch, hideOptions]
    );

    const currentChatInfo = currentChat.data;
    const prospect = currentChatInfo.prospect;

    let prospectView = '';
    if (prospect) {
        prospect.name = prospect.name ? prospect.name.split(' ')[0] : '';
        const online = prospect.last_online
            ? dayjs.duration(dayjs().diff(dayjs(prospect.last_online.updated_at))).asMinutes()
            : 10;

        prospectView = (
            <div key={prospect.id} className="chat-name-head-row">
                <div className={online < 5 ? 'chat-name-img-container mod-online' : 'chat-name-img-container'}>
                    <div
                        className="chat-name-img-block ambassador-chat-image"
                        onClick={() => onAvatarClick(currentChatInfo, hideOptions)}
                    >
                        {prospect.avatar ? (
                            <Image
                                className="chat-name-img"
                                src={prospect.avatar.sizes['70x70'] || prospect.avatar.original || userDefaultAvatar}
                                onError={onUserImgError}
                                alt={prospect.name ? prospect.name : "Deleted User's avatar"}
                            />
                        ) : (
                            <div className="chat-name-img-block chat-name-img-block--border">
                                <div className="chat-name-img--placeholder">
                                    {prospect.name ? prospect.name.slice(0, 1).toUpperCase() : 'D'}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <div className="chat-name-block">
                    <div
                        className="chat-name ambassador-chat-name-header ambassador-chat-name-header-shortened"
                        onClick={() => onAvatarClick(currentChatInfo, hideOptions)}
                    >
                        {prospect.name ? prospect.name : 'Deleted User'}
                    </div>
                    <p className="chat-prospect-name">
                        {prospect.nationality && prospect.nationality.name ? prospect.nationality.name : ''}
                    </p>
                </div>
            </div>
        );
    } else {
        prospectView = (
            <div className="chat-name-head-row">
                <div className="chat-name-block">
                    <h3 className="chat-name">Deleted User</h3>
                </div>
            </div>
        );
    }

    const flagModalChild = (
        <div className={`sub-title ${isMobile ? 'mobile' : ''}`}>
            If you report this conversation, it will be reviewed by an administrator at{' '}
            {currentChat.university ? currentChat.university.name : 'institution'}.
        </div>
    );
    const closeModalChild = (
        <div className="sub-title">
            By closing this conversation, you will no longer be able to chat with{' '}
            {currentChatInfo.members && currentChatInfo.members[0] ? currentChatInfo.members[0].name : 'Deleted user'}.
        </div>
    );
    const leaveModalChild = (
        <div className="sub-title">
            If you leave this conversation, you will no longer be able to chat with{' '}
            {currentChatInfo.members && currentChatInfo.members[0] ? currentChatInfo.members[0].name : 'Deleted user'}.
        </div>
    );

    let prospectMessages = [];
    if (messages.items && messages.items.length > 4 && prospect) {
        prospectMessages = messages.items.filter((message) => message.user_id === prospect.id);
    }

    return (
        <div className="chat-ambassador-header">
            <div className="chat-head-left">{prospectView}</div>
            <div className="chat-header-options-block">
                {messages.items && messages.items.length > 4 && prospect ? (
                    <>
                        {prospectMessages &&
                        prospectMessages.length === 4 &&
                        showHintFeedback &&
                        !currentChatInfo.feedback ? (
                            <>
                                <Popover
                                    placement="bottomRight"
                                    open={true}
                                    overlayStyle={{ width: 320 }}
                                    content={
                                        <div className="feedback-hint">
                                            <p className="feedback-hint-title">
                                                Leave your feedback on {prospect.name}!
                                            </p>
                                            <p className="feedback-hint-body">
                                                When you're ready, please take a couple of minutes to share some
                                                thoughts on your chat with {prospect.name}.
                                            </p>
                                            <Button className="feedback-hint-button" onClick={skipFeedback}>
                                                Skip this
                                            </Button>
                                        </div>
                                    }
                                    onClick={(e) => e.preventDefault()}
                                    overlayClassName="feedback-hint-popover"
                                >
                                    <Button
                                        htmlType="button"
                                        className="sa-feedback-button sa-feedback-button-active sa-feedback-with-mask"
                                        aria-label=""
                                        title="Send feedback"
                                        onClick={showFeedbackModal}
                                    >
                                        <SmileySvg />
                                    </Button>
                                </Popover>
                                <Modal
                                    open={true}
                                    width={0}
                                    centered={true}
                                    footer={null}
                                    closable={false}
                                    maskClosable={false}
                                ></Modal>
                            </>
                        ) : (
                            <Button
                                htmlType="button"
                                className="sa-feedback-button sa-feedback-button-active"
                                aria-label=""
                                title="Send feedback"
                                onClick={showFeedbackModal}
                            >
                                <SmileySvg />
                            </Button>
                        )}
                    </>
                ) : (
                    <Button htmlType="button" className="sa-feedback-button" aria-label="" title="Send feedback">
                        <SmileySvg />
                    </Button>
                )}
                <Button
                    htmlType="button"
                    className={'show-options-button' + (showOptions ? ' pressed' : '')}
                    aria-label="Show options"
                    title="Show options"
                    onClick={handleShowOptionsClickOnMobile}
                >
                    <MenuSvg />
                </Button>
            </div>
            <div className={'chat-head-right mobile' + (showOptions ? ' show-options' : '')}>
                {prospect && (
                    <>
                        <Button
                            className="chat-control"
                            onClick={(e) => onAvatarClick(currentChatInfo, hideOptions, e)}
                        >
                            <div className="option-text">Prospect Information</div>
                        </Button>
                        {!currentChatInfo.closed && (
                            <>
                                <Button className="chat-control invite-users" onClick={handleOpenInviteAdminsPopup}>
                                    <div className="option-text">Invite admin</div>
                                </Button>
                                <Button
                                    className="chat-control invite-users"
                                    onClick={handleOpenInviteAmbassadorsPopup}
                                >
                                    <div className="option-text">Add ambassador</div>
                                </Button>
                            </>
                        )}
                        <Button
                            className="chat-control"
                            disabled={currentChatInfo.user_reported || currentChatInfo.reported}
                            onClick={() => {
                                handleSurePopupClick('handleFlagClick', flagModalChild, true);
                            }}
                        >
                            <div className="option-text">
                                {currentChatInfo.user_reported || currentChatInfo.reported
                                    ? 'Conversation is reported'
                                    : 'Report a conversation'}
                            </div>
                        </Button>
                        <Button
                            className="chat-control leave-conversation"
                            onClick={() => {
                                handleSurePopupClick('leaveChat', leaveModalChild);
                            }}
                        >
                            <div className="option-text">Leave conversation</div>
                        </Button>
                        {!currentChatInfo.closed && (
                            <Button
                                className="chat-control chat-close"
                                onClick={() => {
                                    handleSurePopupClick('closeDialog', closeModalChild);
                                }}
                            >
                                <div className="option-text">Close conversation</div>
                            </Button>
                        )}
                    </>
                )}
            </div>

            <Modal
                open={isFeedbackModalActive}
                styles={{ body: { padding: '30px 26px 50px' } }}
                width={450}
                centered={true}
                footer={null}
                closable={true}
                maskClosable={true}
                onCancel={hideFeedbackModal}
                className="feedback-modal"
                destroyOnClose={true}
            >
                <FeedbackPopup handleClose={() => hideFeedbackModal()} />
            </Modal>
            <Modal
                open={isFeedbackSuccessModalActive}
                styles={{ body: { padding: '35px' } }}
                width={333}
                centered={true}
                footer={null}
                closable={false}
                maskClosable={true}
                onCancel={hideFeedbackSuccessModal}
                className="feedback-modal"
            >
                <div className="feedback-success-modal">
                    <p>Thanks for the feedback!</p>
                    {currentChatInfo.isFirstFeedback && (
                        <p>
                            You've earned <span>50 bonus points!</span>
                        </p>
                    )}
                </div>
            </Modal>
        </div>
    );
};

export default AmbassadorMessagingHeader;
